function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.574 9.6h6.857a.39.39 0 00.381-.4V2c0-.22-.17-.4-.38-.4H4.573a.39.39 0 00-.381.4v7.2c0 .22.17.4.38.4zm6.857 1.6c1.052 0 1.905-.896 1.905-2V2c0-1.104-.853-2-1.905-2H4.574C3.522 0 2.669.896 2.669 2v7.2c0 1.104.853 2 1.905 2h6.857z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.476 11.206V5.601H16v5.625c0 .763-.513 1.269-.99 1.57-.497.315-1.153.545-1.864.715-1.435.345-3.308.5-5.15.488-1.845-.011-3.715-.19-5.145-.54-.71-.173-1.36-.4-1.852-.701-.458-.282-1-.77-1-1.532V5.601h1.525v5.58c.022.03.084.098.244.195.3.184.78.367 1.428.526 1.284.313 3.033.486 4.808.498 1.776.01 3.522-.14 4.802-.448.646-.155 1.121-.338 1.417-.525.182-.116.238-.193.253-.22zm.005-.011l-.003.007a.021.021 0 01.003-.008zm-12.968-.031l.002.005a.017.017 0 01-.002-.005z",
    fill: props.fill
  }));
}
export default SvgSeats;